import { typographyHelper, spacingHelper, mediaHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';

export const TabTitle = styled.h1`
  ${typographyHelper('title03')}
  margin: ${spacingHelper('extraSmall 0 large')};
  ${mediaHelper('tabletMax')} {
    padding: 0 ${spacingHelper('medium')};
  }
`;
